export default "__VITE_ASSET__F7XFFA4Q__"